/// app.js
import * as React from 'react';
import './App.css';
import { ThemeProvider } from "styled-components";
import { theme } from "./utils/theme";
import { GlobalStyle } from "./utils/GlobalStyle";
import AppRoute from "./route/index";
import { Provider } from 'react-redux';
import { store } from './redux/Store';
import "./helpers/i18n";
import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/react-select.css";

function App() {

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AppRoute />
        <GlobalStyle />
      </ThemeProvider>
    </Provider>
  )
}
export default App;
